var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "report-section-item relative flex-grow",
      class: {
        "mode-edit-focused":
          _vm.mode === "edit" && _vm.isFocused && !_vm.isDragging,
        "mode-edit-unfocused":
          _vm.mode === "edit" && !_vm.isFocused && !_vm.isDragging,
        "mode-edit-unfocused-dragging": _vm.isDragging,
        "mode-preview": _vm.mode === "preview",
        "mode-dragging": _vm.mode === "dragging"
      },
      style: { padding: "4px 40px" },
      on: {
        click: function($event) {
          return _vm.onFocus(true)
        }
      }
    },
    [
      _vm.mode === "dragging"
        ? _c("div", {
            staticClass: "absolute left-0 top-0 z-10 h-full w-full flex-grow",
            on: {
              mouseup: function($event) {
                return _vm.$emit("drop-graph")
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "absolute top-0 left-0 flex justify-end flex-shrink-0",
          style: { padding: "4px 8px", width: "40px" }
        },
        [
          _vm.mode === "edit" || _vm.mode === "dragging"
            ? _c(
                "div",
                { staticClass: "handle cursor-grab" },
                [
                  _c("BlIcon", {
                    style: { height: "20px", width: "20px" },
                    attrs: { icon: "drag", color: "slate-8" }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.section.kind == "text" || _vm.section.kind.includes("heading")
        ? _c(
            "div",
            [
              _c("TextEditor", {
                attrs: {
                  section: _vm.section,
                  mode: _vm.mode,
                  isFocused: _vm.isFocused
                },
                on: {
                  "change-saving": function($event) {
                    return _vm.$emit("change-saving", $event)
                  },
                  "change-focus-id": function($event) {
                    return _vm.$emit("change-focus-id", $event)
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.section.kind.includes("graph")
        ? _c(
            "div",
            {
              staticClass: "w-full flex flex-wrap oject-center justify-center"
            },
            [
              _c("ReportGraph", {
                attrs: {
                  section: _vm.section,
                  mode: _vm.mode,
                  isFocused: _vm.isFocused,
                  isDragging: _vm.isDraggingGraph
                },
                on: {
                  "change-saving": function($event) {
                    return _vm.$emit("change-saving", $event)
                  },
                  "change-focus-id": function($event) {
                    return _vm.$emit("change-focus-id", $event)
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2214ab36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2214ab36","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/editor/SectionItem.vue
// module id = null
// module chunks = 